function getFileParts(originalName: string): { baseName: string; extension: string } {
  const lastDotIndex = originalName.lastIndexOf(".");
  const baseName =
    lastDotIndex > 0 ? originalName.slice(0, lastDotIndex) : originalName;
  const extension =
    lastDotIndex > 0 ? originalName.slice(lastDotIndex).toLowerCase() : "";

  return { baseName, extension };
}

export function normalizeUploadFileName(originalName: string): string {
  const { baseName, extension } = getFileParts(originalName);
  const normalizedBase = baseName
    .normalize("NFKD")
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_")
    .toLowerCase();

  return `${normalizedBase || "document"}${extension}`;
}

export function normalizeUploadFile(file: File): File {
  const normalizedName = normalizeUploadFileName(file.name);
  if (normalizedName === file.name) return file;

  return new File([file], normalizedName, {
    type: file.type,
    lastModified: file.lastModified,
  });
}

export function normalizeUploadFiles(files: File[] | FileList): File[] {
  return Array.from(files).map((file) => normalizeUploadFile(file));
}
